module.exports = __webpack_public_path__ + "img/h3.4141bd1a.png";